<template>
  <v-card class="mx-0" tile>
    <v-container>
      <v-row
        class="m-0 pointer"
        tile
        v-for="(dt, idx) in penunjanglain"
        :class="{ 'active-list': activeId === dt.id }"
        :key="idx"
        style="border-bottom: solid gray 1px"
        @click="getPenunjangLain(dt, idx)"
      >
        <v-hover v-slot="{ hover }">
          <v-col cols="12" v-ripple :class="{ 'hover-list': hover }">
            <span class="font-weight-bold h5">
              {{ dt.penunjang_lain_kategori.nama }}
            </span>
            <span class="float-right">
              {{ getHumanDate(dt.waktu_periksa) }}
            </span>
          </v-col>
        </v-hover>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import pdf from "vue-pdf";
import moment from "moment";

@Component({
  components: {
    pdf,
  },
})
export default class DetailPenunjangLain extends Vue {
  @Prop() penunjanglain;
  @Prop() selectedDetail;
  @Prop() showEdit;
  @Prop() panelriwayat;
  @Prop() showdetail;
  @Prop() activeId;

  dtfile = "";
  show = true;

  loadedRatio = 0;
  page = 1;
  numPages = 0;
  rotate = 0;
  editShow = true;
  showFile = false;

  mounted() {
    // console.log("select", this.panelriwayat);
  }
  @Watch("showdetail")
  showdetail() {
    if (this.showdetail == false) {
      this.showFile = false;

      this.activeId = "";
    }
  }
  @Watch("panelriwayat")
  changed() {
    // if (this.panelriwayat && this.panelriwayat.length < 1) {
    //   // ac
    //   this.activeId = {};
    //   this.showFile = false;
    // }
    if (this.panelriwayat == undefined) {
      this.showFile = false;
    }
    // console.log(this.showFile);
  }
  // get statepenunjanglain() {
  //   return storePenunjang.penunjanglain;
  // }
  getPenunjangLain(itemall) {
    // this.activeId = itemall.id;
    this.$emit("show-item", itemall);
  }
  error(err) {
    console.log(err);
  }
  getHumanDateTime(date) {
    return date ? moment(date).format("DD MMMM YYYY HH:mm:ss") : "";
  }
  getHumanDate(date) {
    return date ? moment(date).format("DD MMMM YYYY") : "";
  }
}
</script>

<style scoped>
.v-list {
  height: 200px;
  overflow-y: auto;
}
.pointer {
  cursor: pointer;
}
.active-list {
  background: lightgrey;
}
.scroll {
  overflow-y: scroll;
}
</style>
